import React from 'react';
import { styled, useTheme } from '@volkswagen-onehub/components-core';
import { applyCustomStyles } from '../utils';

interface BoxProps extends React.HTMLAttributes<HTMLElement> {
  style?: React.CSSProperties;
  component?: keyof JSX.IntrinsicElements;
  className?: string;
  [key: string]: any;
}

const StyledBox = styled.div.withConfig({
  shouldForwardProp: (prop) => prop !== '$customStyles',
})<{ $customStyles?: React.CSSProperties }>`
  ${({ $customStyles }) => applyCustomStyles($customStyles)}
`;

export const Box = React.forwardRef<HTMLElement, BoxProps>(
  ({ children, component = 'div', style, ...rest }, ref) => {
    const theme = useTheme();
    const resolvedStyle = typeof style === 'function' ? style(theme) : style;

    return (
      <StyledBox
        as={component}
        ref={ref}
        $customStyles={resolvedStyle}
        {...rest}
      >
        {children}
      </StyledBox>
    );
  }
);

Box.displayName = 'Box';
